import React from 'react';
import {
  Box,
  Text,
  Flex,
  FormControl,
  FormLabel,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useColorMode,
} from '@chakra-ui/react';
import EmojiPicker from 'emoji-picker-react';

// `boxSize` makes the default variant a square of that size instead of the
// 80x40 field it renders at otherwise.
export default function EmojiPickerField({ label, value, onChange, placeholder = '🚗', variant = 'default', boxSize }) {
  const displayEmoji = value || placeholder;
  const isPlaceholder = !value;
  // The picker draws its own panel, light unless told otherwise.
  const { colorMode } = useColorMode();

  if (variant === 'inline') {
    return (
      <Popover placement="bottom-start" strategy="fixed">
        {({ onClose }) => (
          <>
            <PopoverTrigger>
              <Flex
                align="center"
                cursor="pointer"
                _hover={{ opacity: 0.8 }}
                transition="all 0.15s"
                gap={1}
              >
                <Text
                  fontSize={{ base: "lg", md: "xl" }}
                  opacity={isPlaceholder ? 0.4 : 1}
                >
                  {displayEmoji}
                </Text>
                <Text fontSize="xs" color="redesign.text.muted">▾</Text>
              </Flex>
            </PopoverTrigger>
            <PopoverContent w="350px" borderRadius="lg" border="none">
              <PopoverBody p={0}>
                <EmojiPicker
                  onEmojiClick={(emojiData) => {
                    onChange(emojiData.emoji);
                    onClose();
                  }}
                  width="100%"
                  height={350}
                  searchPlaceholder="Search emoji..."
                  previewConfig={{ showPreview: false }}
                  theme={colorMode}
                />
              </PopoverBody>
            </PopoverContent>
          </>
        )}
      </Popover>
    );
  }

  return (
    <FormControl w={boxSize || '80px'}>
      {label && <FormLabel>{label}</FormLabel>}
      <Popover placement="bottom-start" strategy="fixed">
        {({ onClose }) => (
          <>
            <PopoverTrigger>
              <Box
                h={boxSize || '40px'}
                border="1px solid"
                borderColor={boxSize ? 'redesign.border' : 'redesign.border.strong'}
                borderRadius={boxSize ? 'lg' : 'md'}
                display="flex"
                alignItems="center"
                justifyContent="center"
                cursor="pointer"
                _hover={{ borderColor: "redesign.text.muted" }}
                transition="all 0.15s"
                fontSize="xl"
                opacity={isPlaceholder ? 0.4 : 1}
              >
                {displayEmoji}
              </Box>
            </PopoverTrigger>
            <PopoverContent w="350px" borderRadius="lg" border="none">
              <PopoverBody p={0}>
                <EmojiPicker
                  onEmojiClick={(emojiData) => {
                    onChange(emojiData.emoji);
                    onClose();
                  }}
                  width="100%"
                  height={350}
                  searchPlaceholder="Search emoji..."
                  previewConfig={{ showPreview: false }}
                  theme={colorMode}
                />
              </PopoverBody>
            </PopoverContent>
          </>
        )}
      </Popover>
    </FormControl>
  );
}
